import { render, staticRenderFns } from "./TaskCommentModal.vue?vue&type=template&id=6e64e3f0&"
import script from "./TaskCommentModal.vue?vue&type=script&lang=js&"
export * from "./TaskCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports